import { useEffect, useRef } from "react";
import { useGlobalOrder } from "../../utils/GlobalStateContext";
import { useTodayReservations } from "./TodayReservationsProvider";
import { pickReservationsToNotify, reservationNotifyMessage } from "./reservationUtils";

// 全域預約提醒：掛在 MainMenu 最外層，人員不管在哪一頁都會跳 toast：
// 送單前 10 分鐘先預告一次；到送單時間還沒按「開始製作」（或已逾時）每 5 分鐘再提醒，結帳台(POS1)另外響鈴。
export default function ReservationReminder() {
  const { toast, playBeep, systemData } = useGlobalOrder();
  const { reservations, nowMs } = useTodayReservations();
  const notifiedKeys = useRef(new Set());

  useEffect(() => {
    const picked = pickReservationsToNotify(reservations, nowMs, notifiedKeys.current);
    if (!picked.length) return;

    picked.forEach(({ order, timing }) => {
      const notify = timing === "soon" ? toast.info : toast.warning;
      notify(reservationNotifyMessage(order, timing), {
        autoClose: 15000,
        closeOnClick: true,
        onClick: () => {
          window.dispatchEvent(new CustomEvent("pos-navigate", { detail: "/reservations" }));
        },
      });
    });

    if (Number(systemData?.position_id) === 1) {
      playBeep();
    }
  }, [reservations, nowMs, toast, playBeep, systemData?.position_id]);

  return null;
}
